import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import useSWR from '../../hooks/useSWR'

import StatisticsIframe from './StatisticsIframe'
import ExploringDashboard from '../Exploring/ExploringDashboard'

/* 12h */
const refreshInterval = 60 * 60 * 12 * 1000

const pages = ['xBTUB', 'iIVUB', 'U6VUB']

const areStatsAvailable = (type, locks = []) => {
  if (type === 'carrier' || type === 'vendor') return true

  return locks.some((l) => l.sub_type === 'container')
}

const Statistics = () => {
  const admin = useSelector((state) => state.collectionData.admin)
  const locks = useSelector((state) => state.collectionData.locks)

  const { data: statistics } = useSWR(admin && `/subject/${admin.type}/statistics/token`, { refreshInterval, revalidateOnFocus: false })

  const [activePage, setActivePage] = useState(admin && admin.type === 'admin' ? 'exploring' : 'iIVUB')

  if (!admin) return null

  const isAdminAndHasQinsightRole = admin.type !== 'admin' || admin.user?.roles?.includes('dataanalytics')
  const isAhlsellVendor = admin.type === 'vendor' && admin.user?.name === 'Ahlsell'

  return (
    <div style={{ height: 3000 }}>
      {areStatsAvailable(admin.type, locks) && (
        <div style={{ zIndex: 999, marginBottom: 40 }}>
          {admin.type === 'admin' && (
            <button style={{ padding: 10, color: activePage === 'exploring' ? '#FFF' : '#000F', background: activePage === 'exploring' ? '#006e78' : '#FFF' }} onClick={() => setActivePage('exploring')}>
              Utforska
            </button>
          )}
          <button style={{ padding: 10, color: activePage === 'iIVUB' ? '#FFF' : '#000F', background: activePage === 'iIVUB' ? '#006e78' : '#FFF' }} onClick={() => setActivePage('iIVUB')}>
            Anlöpsstatistik
          </button>
          <button style={{ padding: 10, color: activePage === 'U6VUB' ? '#FFF' : '#000F', background: activePage === 'U6VUB' ? '#006e78' : '#FFF' }} onClick={() => setActivePage('U6VUB')}>
            Nyttjandegrad
          </button>
          {isAdminAndHasQinsightRole && !isAhlsellVendor && (
            <button style={{ padding: 10, color: activePage === 'xBTUB' ? '#FFF' : '#000F', background: activePage === 'xBTUB' ? '#006e78' : '#FFF' }} onClick={() => setActivePage('xBTUB')}>
              Avvikelser
            </button>
          )}
        </div>
      )}
      {activePage === 'exploring' && <ExploringDashboard />}
      <div>{statistics && pages.map((page) => <StatisticsIframe key={page} isVisible={page === activePage} page={page} token={statistics.token} admintype={admin.type} />)}</div>
    </div>
  )
}

export default Statistics
